// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyABtRO7jjzPVCoyYCy-H4ZzzhRTCUB9Mbs",
  authDomain: "mrehab-88593.firebaseapp.com",
  projectId: "mrehab-88593",
  storageBucket: "mrehab-88593.firebasestorage.app",
  messagingSenderId: "524239522556",
  appId: "1:524239522556:web:e9ca939c38fddf4919a579",
  measurementId: "G-KD0B778MS7",
};

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
